<template src="./template.html"></template>
<script>
// import _get from 'lodash/get';

import facebookLib from 'lib/facebook'
// import googleLib from 'lib/google';
import authService from 'api/auth'
import eventBus from 'lib/eventBus'
import analyticsLib from 'lib/analytics'
import TRACKING_EVENTS from 'constants/trackingEvents'

const TABS = {
  LOGIN: 'LOGIN',
  SIGNUP: 'SIGNUP',
  FORGOT: 'FORGOT',
  RESET: 'RESET',
}

export default {
  name: 'login',
  props: {
    startOnSignUp: {
      type: Boolean,
      default: false,
    },
    enableGuestCheckout: {
      type: Boolean,
      default: false,
    },
    enableOnlyGuestCheckout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TABS,
      currentTab: TABS.LOGIN,
      loadingGuest: false,
      loading: false,
      loadingFb: false,
      loadingGoogle: false,
      loginForm: {
        email: null,
        password: null,
      },
      signupForm: {
        email: null,
        password: null,
      },
      forgotPasswordForm: {
        email: null,
      },
      errorMessage: null,
      showPasswordReset: false,
    }
  },
  methods: {
    goToLogin() {
      this.errors.clear()

      this.currentTab = TABS.LOGIN
      this.errorMessage = null
      this.showPasswordReset = false
    },
    goToSignup() {
      this.errors.clear()

      this.currentTab = TABS.SIGNUP
      this.errorMessage = null
      this.showPasswordReset = false
    },
    goToForgotPassword() {
      this.errors.clear()

      this.currentTab = TABS.FORGOT
      this.errorMessage = null
      this.showPasswordReset = false
    },
    loginGuest() {
      return this.$store
        .dispatch('logout')
        .then(() => {
          return this.$store.dispatch('getCurrentUser')
        })
        .then(() => {
          this.loadingGuest = false
        })
    },
    loginFacebook() {
      this.loadingFb = true

      return facebookLib
        .login()
        .then((authResponse) => {
          const auth = authResponse.authResponse || {}

          return authService.loginFacebook({
            facebookToken: auth.accessToken,
          })
        })
        .then((result) => {
          this.loadingFb = false

          return this.$store.dispatch('login', result)
        })
        .then(() => {
          return this.$store.dispatch('getCurrentUser')
        })
        .catch((err) => {
          this.loadingFb = false

          this.errorMessage = err.message
        })
    },
    // loginGoogle() {
    //   this.loadingGoogle = true;
    //
    //   return googleLib.login()
    //     .then(authResponse => {
    //       let accessToken;
    //
    //       const keys = Object.keys(authResponse);
    //
    //       for (let i = 0; i < keys.length; i++) { //eslint-disable-line
    //         const key = keys[i];
    //
    //         accessToken = _get(authResponse, `${key}.access_token`);
    //
    //         if (accessToken) {
    //           break;
    //         }
    //       }
    //
    //       return authService.loginGoogle({
    //         googleToken: accessToken
    //       });
    //     })
    //     .then(result => {
    //       this.loadingGoogle = false;
    //
    //       return this.$store.dispatch('login', result);
    //     })
    //     .then(() => {
    //       return this.$store.dispatch('getCurrentUser');
    //     })
    //     .catch(err => {
    //       this.loadingGoogle = false;
    //
    //       this.errorMessage = err.message;
    //     });
    // },
    loginEmail(scope) {
      this.errorMessage = null

      this.$validator.validateAll(scope).then((success) => {
        if (success) {
          this.loading = true

          authService
            .login({
              email: this.loginForm.email,
              password: this.loginForm.password,
            })
            .then((result) => {
              return this.$store.dispatch('login', result)
            })
            .then(() => {
              return this.$store.dispatch('getCurrentUser')
            })
            .catch((err) => {
              this.loading = false

              this.errorMessage = err.message
            })
        }
      })
    },
    signupEmail(scope) {
      this.$validator.validateAll(scope).then((success) => {
        if (success) {
          this.loading = true

          authService
            .register({
              firstName: this.signupForm.firstName,
              lastName: this.signupForm.lastName,
              email: this.signupForm.email,
              password: this.signupForm.password,
            })
            .tap(() => {
              return this.trackSignedUp()
            })
            .then((result) => {
              this.$emit('login')

              return this.$store.dispatch('login', result)
            })
            .then(() => {
              return this.$store.dispatch('getCurrentUser')
            })
            .catch((err) => {
              this.loading = false

              this.errorMessage = err.message
            })
        }
      })
    },
    resetPassword(scope) {
      this.$validator.validateAll(scope).then((success) => {
        if (success) {
          this.loading = true

          authService
            .forgotPassword({
              email: this.forgotPasswordForm.email,
            })
            .then(() => {
              this.currentTab = TABS.RESET
              this.loading = false

              return this.trackForgotPassword()
            })
            .catch((err) => {
              this.loading = false

              this.errorMessage = err.message
            })
        }
      })
    },
    //tracking
    trackForgotPassword() {
      return analyticsLib.trackEvent(TRACKING_EVENTS.ForgotPassword, {})
    },
    trackSignedUp() {
      return analyticsLib.trackEvent(TRACKING_EVENTS.SignedUp, {})
    },
  },
  created() {
    this.loadingGuest = true

    if (this.startOnSignUp) {
      this.currentTab = TABS.SIGNUP
    }

    if (this.enableOnlyGuestCheckout) {
      this.loginGuest()
    } else {
      this.loadingGuest = false
    }
  },
  updated() {
    eventBus.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Login/index.vue